var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#112ebc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0620a0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e3264a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d20f34"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#j"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    fillRule: "evenodd",
    height: 4.571429,
    rx: 0.380952,
    width: 5.333333
  })), /*#__PURE__*/React.createElement("mask", {
    id: "h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    fillRule: "evenodd",
    height: 4.571429,
    rx: 0.380952,
    width: 5.333333
  })), /*#__PURE__*/React.createElement("mask", {
    id: "i",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    fillRule: "evenodd",
    height: 4.571429,
    rx: 0.380952,
    width: 5.333333
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v5.333333h-16z",
    fill: "url(#c)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 5.333333h16v6.095238h-16z",
    fill: "url(#d)",
    mask: "url(#e)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.333333 3.809524)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#a)",
    fillRule: "nonzero",
    height: 4.571429,
    rx: 0.380952,
    width: 5.333333
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#f)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3.047619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 .76190476.84212948-.42106474c.37648149-.18824074 1.01894506-.34084002 1.4427898-.34084002h.76349477c.42034931 0 1.06947535.1541828 1.44278981.34084002l.84212947.42106474v.76190476h-5.33333333z",
    fill: "#aabcae",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.19047619.87962552v.45370781h4.95238095v-.45370781l-.73683683-.36841841c-.34799092-.17399546-.96807996-.32073092-1.35760626-.32073092h-.76349477c-.39303206 0-1.00645761.1451566-1.35760626.32073092z",
    stroke: "#366c14",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 2.666667,
    cy: 1.904762,
    fill: "#d4b872",
    fillRule: "nonzero",
    mask: "url(#g)",
    r: 1.142857
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#h)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.761905 1.52381)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    id: "j",
    d: "m0 .76640937c0-.21288202.13698578-.27586836.29761905-.14736175l1.30952381 1.04761905c.16437046.13149636.43460482.12850661.59523809 0l1.30952381-1.04761905c.16437046-.13149637.29761905-.06231399.29761905.14736175v1.13384793c0 .21288201-.16369048.38545699-.37919907.38545699h-3.05112567c-.20942586 0-.37919907-.17578125-.37919907-.38545699z",
    fill: "#c28321"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m.19047619.77726187v1.12299543c0 .10651655.08653084.1949808.18872288.1949808h3.05112567c.10702014 0 .18872288-.08398161.18872288-.1949808v-1.12299543l-1.29767714 1.03814171c-.231277.18502161-.60034647.18629655-.83321715 0z",
    stroke: "#0d3488",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m1.65490977.89300501c-.07240467-.07240467-.04428863-.13110025.06377847-.13110025h1.89595686c.10762854 0 .13343375.06144496.06377847.13110025l-.88065666.88065665c-.07240466.07240466-.1925452.06965528-.26220049 0z",
    fill: "#216c30",
    fillRule: "nonzero",
    mask: "url(#i)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHt);
export default __webpack_public_path__ + "static/media/HT.d64f1a33bab4b3d33e67dbd1afd7da57.svg";
export { ForwardRef as ReactComponent };